import { type AnyRouter, RouterProvider } from '@tanstack/react-router';

import { useCogniteClient } from '#hooks/useCogniteClient';

export interface AppProps {
  router: AnyRouter;
}

export function App({ router }: AppProps) {
  const cogniteClient = useCogniteClient();
  return <RouterProvider router={router} context={{ cogniteClient }} />;
}
